import React from 'react';
import { AskRequest } from '@hone-automation/common/lib/AskRequests';
import { MobileSlideUpPanel } from 'presentation/components/Mobile/MobileSlideUpPanel/MobileSlideUpPanel';
import InfoPanel from 'presentation/components/Queue/panels/InfoPanel/InfoPanel';
import { useQueueRequestsQuery } from 'hooks/useQueueRequestsQuery';
import './RequestInfoPanel.scss';

interface RequestInfoPanelProps {
  requestId: string;
  isOpen: boolean;
  onClose: () => void;
  titleIcon?: React.ReactNode; // Optional icon to display in the panel header
}

/**
 * Mobile-specific wrapper for the InfoPanel component
 * This component fetches the request data and passes it to the InfoPanel
 */
const RequestInfoPanel: React.FC<RequestInfoPanelProps> = ({ requestId, isOpen, onClose, titleIcon }) => {
  // Fetch the request data
  const { data: requests, isLoading, error } = useQueueRequestsQuery();

  // Find the request with the matching ID
  const request = requests?.find(req => req.id === requestId);

  return (
    <MobileSlideUpPanel
      isOpen={isOpen}
      onClose={onClose}
      title="Request Information"
      fullSizeOnOpen={true}
      titleIcon={titleIcon}
    >
      <div className="mobile-info-panel-wrapper">
        {isLoading ? (
          <div className="loading-indicator">Loading request data...</div>
        ) : error ? (
          <div className="error-message">Error loading request data</div>
        ) : !request ? (
          <div className="error-message">Request not found</div>
        ) : (
          <InfoPanel request={request} className="mobile-info-panel" />
        )}
      </div>
    </MobileSlideUpPanel>
  );
};

export default RequestInfoPanel;
